import {
  createSlice,
  PayloadAction,
  // createAsyncThunk,
  // createDraftSafeSelector,
} from "@reduxjs/toolkit";
import { RootState } from "store";

// active 状态的类型： 企业、部门、员工
export const ACTIVETYPE = {
  STAFF: "STAFF",
  DEPARTMENT: "DEPARTMENT",
  COMPANY: 'COMPANY'
}
// 弹窗类型 通讯录 分配导师
export const ADDRESSBOOKTYPE = {
  ADDRESSBOOK: "ADDRESSBOOK",
  ASSIGNTUTOR: "ASSIGNTUTOR"
}

interface IInitialState {
  addressModalItem: {
    visible: boolean,
    department_id?: string | number,
    keyword?: string,
    type?: string
  },
  assignTutorItem: {
    action?: any,
    callback?: any,

    data: {
      staff_id?: number | string,
      staff_name?: string
      department_name?: string
      position_name?: string
      avatar_id?: string
    }
  }
  activeData?: any
}

const initialState: IInitialState = {
  addressModalItem: {
    visible: false,
    department_id: '',
    keyword: '',
    // 弹窗类型：分配导师、企业通讯录
    type: ADDRESSBOOKTYPE.ASSIGNTUTOR,
  },
  // 待分配导师的员工
  assignTutorItem: {
    action: 1,
    callback: {},
    data: {
      staff_id: '',
      staff_name: "",
      department_name: "",
      position_name: '',
      avatar_id: "",
    }
  },
  // active状态的 部门或者员工
  activeData: null
};

export const taskSlice = createSlice({
  name: "addressBook",
  initialState: initialState,
  reducers: {
    setAddressBook: (state, action: PayloadAction<any>) => {
      state.addressModalItem = Object.assign({}, state.addressModalItem, action.payload,);
    },
    setAddressBookActiveData: (state, action: PayloadAction<any>) => {
      state.activeData = action.payload;
    },
    setAssignTutorItem: (state, action: PayloadAction<any>) => {
      state.assignTutorItem = action.payload;
    }
  },
});

export const mapAddressBook = (state: RootState) => state.addressBook.addressModalItem;
export const mapAddressBookActive = (state: RootState) => state.addressBook.activeData;
export const mapAssignTutorItem = (state: RootState) => state.addressBook.assignTutorItem;

export const { setAddressBook, setAddressBookActiveData, setAssignTutorItem } = taskSlice.actions;

export default taskSlice.reducer;
